// @core/api/endpoints/audittrail/update_retention_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  RetentionPolicyResponse,
  UpdateRetentionPolicyRequest,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Update retention policy
 * Updates a retention policy's rules, compliance framework, or purge strategy.
 */
export async function UpdateRetentionPolicy(
  policy_id: string,
  data: UpdateRetentionPolicyRequest,
  options?: RequestOptions
): Promise<RetentionPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/audit/retention-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.put<RetentionPolicyResponse>(requestPath, data, requestOptions);
}
